import request from '@/utils/requestnew'
import baseUrl from './baseUrl'
import commonJs from '@/utils/common'

const BASE_URL = baseUrl + '/youzan'

export default {
    //列表接口
    list(params) {
        params = params && commonJs.obj.removeNullKey(params)
        return request({
            url: BASE_URL + '/list',
            method: 'get',
            params
        })
    },

    //添加
    add(data) {
        return request({
            url: BASE_URL + '/add',
            method: 'post',
            data
        })
    },

    //编辑
    update(data) {
        return request({
            url: BASE_URL + '/edit',
            method: 'post',
            data
        })
    },

    //删除
    delete(params) {
        params = params && commonJs.obj.removeNullKey(params)
        return request({
            url: BASE_URL + '/delete',
            method: 'get',
            params
        })
    },
    //状态修改
    change(params) {
        params = params && commonJs.obj.removeNullKey(params)
        return request({
            url: BASE_URL + '/change',
            method: 'get',
            params
        })
    },


}